import { SortOptions } from './CommonSortOptions';
import { OptionsDictionary } from './SortOptionDefinitions';

export const publishedConnectionSortOptions: OptionsDictionary = {
  'relevance': SortOptions.relevance,
  'name': SortOptions.name,
  'owner': SortOptions.owner,
  'projectName': SortOptions.projectName,
  'updated': SortOptions.updated,
};

export const publishedConnectionTableSortOptions: OptionsDictionary = {
  'name': SortOptions.name,
};

export const publishedConnectionColumnSortOptions: OptionsDictionary = {
  'name': SortOptions.name,
};